import { ProvedorToast } from '@persona/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErroApi } from './api/erros';
import { instalarAtalhos } from './atalhos/registro';
import { roteador } from './roteador';
import { ProvedorSessao } from './sessao/sessao';
import './app.css';

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      // 4xx é resposta, não falha transitória: não repete.
      retry: (n, e) => !(e instanceof ErroApi && e.status >= 400 && e.status < 500) && n < 2,
    },
  },
});

instalarAtalhos();

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <ProvedorToast>
        <ProvedorSessao>
          <RouterProvider router={roteador} />
        </ProvedorSessao>
      </ProvedorToast>
    </QueryClientProvider>
  </StrictMode>,
);
